import { useCallback } from "react";
import {
  NavigateFunction,
  NavigateOptions,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useUserId } from "./use-user-id";

export const useNavigateWithUserId = () => {
  const navigate = useNavigate();
  const userId = useUserId();
  const location = useLocation();

  const role = location.pathname.split("/")[2] || "trader";

  const navigateWithUserId: NavigateFunction = useCallback(
    (path, options?: NavigateOptions) => {
      return navigate(`/${userId}/${role}/${path}`, options);
    },
    [navigate, role, userId]
  );

  return navigateWithUserId;
};
